module.exports = __webpack_public_path__ + "img/background_poker.9be435e4.png";